var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"honor-swiper"},[_c('div',{staticClass:"grid"},_vm._l((_vm.items),function(item){return _c('div',{key:item.title,staticClass:"card"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":item.image,"alt":item.title}})]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }